import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, computed, watch } from 'vue'
import { useAppState } from '@/services/composition'

import AppService from './services/AppService'

import XRPage from './pages/XRPage.vue'
import DesktopPage from './pages/DesktopPage.vue'
import LoadingPage from './pages/LoadingPage.vue'
import LandingPage from './pages/LandingPage.vue'
import CompanionPage from './pages/CompanionPage.vue'
import { Role } from './services/states/AppStateMachine'



export default /*#__PURE__*/_defineComponent({
  setup(__props) {


onMounted(()=>{
  AppService.start()

  window.addEventListener('CookiebotOnAccept', updateCookiebotWidget)
})

const { state } = useAppState()

const page = computed(() => {
  const stateVal = state.value
  if (stateVal.matches('vr')
    || (stateVal.matches('sync') && stateVal.context.role === Role.XR)) return XRPage
  if (stateVal.matches('initializing')) return LoadingPage
  if (stateVal.matches('landing')) return LandingPage
  if (stateVal.matches('desktop')) return DesktopPage
  if (stateVal.matches('companion')
    || (stateVal.matches('sync') && stateVal.context.role === Role.Companion)) return CompanionPage
})

const key = computed(() => {
  const stateVal = state.value
  if (stateVal.matches('vr') || (stateVal.matches('sync') && stateVal.context.role === Role.XR)) {
    return 'xr'
  }
  if (stateVal.matches('initializing')) {
    return 'loading'
  }
  if (stateVal.matches('landing')) {
    return 'landing'
  }
  if (stateVal.matches('desktop')) {
    return 'desktop'
  }
  if (stateVal.matches('companion') || (stateVal.matches('sync') && stateVal.context.role === Role.Companion)) {
    return 'companion'
  }
})

watch(key, () => {
  updateCookiebotWidget()
})

const updateCookiebotWidget = () => {
  const widget = document.getElementById('CookiebotWidget')
  if (!widget) {
    return
  }
  if (widget && key.value !== 'landing') {
    widget.style.display = 'none'
  } else {
    widget.style.display = 'block'
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(page)), { key: _unref(key) }))
}
}

})